import type { Network } from 'types/shared';
import datadogActions, { DATADOG_EVENT } from './index';

interface EmergencyToggledParams {
  network: Network;
  status: 'enabled' | 'disabled';
}

export const trackEmergencyToggle = ({ network, status }: EmergencyToggledParams) => {
  datadogActions.trackDatadogAction(DATADOG_EVENT.emergencyToggled, {
    network,
    status,
    action: status === 'enabled' ? 'enable_all_rules' : 'emergency_stop',
  });
};
